import * as yup from 'yup';

import { GET_IN_TOUCH_DATA_FIELDS, GET_IN_TOUCH_REQUEST_TYPES } from '@clearverify/constants';

const fileValidationSchema = yup.object({
  fileId: yup.string().required(),
  loading: yup.boolean().isFalse(),
  valid: yup.boolean().isTrue(),
});

export const getInTouchDataValidationSchema = yup.object({
  [GET_IN_TOUCH_DATA_FIELDS.requestType]: yup.string().required('Required Request Type'),
  [GET_IN_TOUCH_DATA_FIELDS.description]: yup.string().required('Required Description'),
  [GET_IN_TOUCH_DATA_FIELDS.attachments]: yup.array().of(fileValidationSchema).notRequired(),
  [GET_IN_TOUCH_DATA_FIELDS.dataDispute]: yup.string().when(GET_IN_TOUCH_DATA_FIELDS.requestType, {
    is: (requestType: GET_IN_TOUCH_REQUEST_TYPES) =>
      requestType === GET_IN_TOUCH_REQUEST_TYPES.dataDispute,
    then: schema => schema.required('Required Data Dispute'),
    otherwise: schema => schema.notRequired(),
  }),
  [GET_IN_TOUCH_DATA_FIELDS.verificationRequest]: yup
    .string()
    .when(GET_IN_TOUCH_DATA_FIELDS.requestType, {
      is: (requestType: GET_IN_TOUCH_REQUEST_TYPES) =>
        requestType === GET_IN_TOUCH_REQUEST_TYPES.verificationRequest,
      then: schema => schema.required('Required Verification Request'),
      otherwise: schema => schema.notRequired(),
    }),
});
